<app-modal-v2 #modal customClassName="trial-notification-template-form">
  <div class="modal-content">

    <div class="modal-header">
      <h2 class="modal-title">Trial Notification Settings</h2>

      <div class="culture-select">
        <app-input-select #cultureSelect [items]="filteredCultures" [parentForm]="form" controlName="selectedCulture"
                          [allowFiltering]="true" [allowClear]="false" (onFilter)="onCultureFiltered($event)"
                          searchInputPlaceholder="Search..."></app-input-select>
      </div>
    </div>
    <div class="modal-body">
      @for (cultureForm of cultureForms; track form) {
        <form [formGroup]="cultureForm"
              [class.visibility-hidden]="cultureForm.value.culture !== form.value.selectedCulture">
          <div class="form-group">
            <label for="text">Patient Notification & Reminders Text</label>
            <app-editor formControlName="text"></app-editor>
            <span class="note">Use this text to guide patients when they’re setting their reminder preferences.</span>
          </div>
        </form>
      }

    </div>

    <div class="modal-footer">
      <div class="modal-footer-buttons">
        <app-button text="Cancel" variant="secondary" width="fill"
                    type="button" (click)="modal.hide()"/>

        <app-button text="Save" variant="primary" width="fill" [isBusy]="form.value.isBusy"
                    [disabled]="!form.valid"
                    type="button"
                    (click)="onSubmit()"/>
      </div>
    </div>

  </div>
</app-modal-v2>
